export const generateId = () => Math.floor(Math.random() * Date.now())
